import styled from 'styled-components';

type ILanguageStyled = {
  blockWidth?: string;
};

export const LanguageStyled = styled.div<ILanguageStyled>`
  display: flex;
  align-items: center;
  cursor: pointer;
  width: ${({ blockWidth }) => blockWidth || '100%'};
`;
